import React from "react";
import { Box } from "@twilio-paste/core";

export type AvatarColumnProps = {
  statusColor?: "colorBackgroundSuccess" | "colorBackgroundWeak";
  imageUrl?: string | null;
  alt?: string;
};

const DefaultAvatarIcon: React.FC = () => (
  <svg
    viewBox="0 0 64 64"
    width="100%"
    height="100%"
    aria-hidden="true"
    focusable="false"
    preserveAspectRatio="xMidYMid meet"
    style={{ display: "block" }}
  >
    <circle cx="32" cy="32" r="32" fill="#EEF1F5" />

    <circle cx="32" cy="26" r="13" fill="#C9D0D8" />

    <path d="M14 64c0-12.2 8.1-21.2 18-21.2S50 51.8 50 64" fill="#C9D0D8" />
  </svg>
);

export const AvatarColumn: React.FC<AvatarColumnProps> = ({
  statusColor = "colorBackgroundSuccess",
  imageUrl,
  alt = "Avatar",
}) => {
  const hasImage = typeof imageUrl === "string" && imageUrl.trim().length > 0;

  return (
    <Box
      marginRight="space20"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Box
        width="50px"
        height="50px"
        borderRadius="borderRadiusCircle"
        overflow="hidden"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {hasImage ? (
          <img
            src={imageUrl}
            alt={alt}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        ) : (
          <DefaultAvatarIcon />
        )}
      </Box>
    </Box>
  );
};
